// Sample resume data for template previews in gallery
export const getSampleResumeData = () => {
  return {
    // Personal Information
    fullName: "John Doe",
    title: "Senior Software Engineer",
    email: "john.doe@email.com",
    phone: "+1 (555) 123-4567",
    location: "San Francisco, CA",
    linkedin: "https://linkedin.com/in/johndoe",
    github: "https://github.com/johndoe",
    portfolio: "https://johndoe.dev",
    website: "https://blog.johndoe.dev",

    // Professional Summary
    summary: "Results-driven Software Engineer with 8+ years of experience building scalable web applications and leading cross-functional teams. Expertise in React, Node.js, and cloud architecture. Proven track record of delivering high-impact solutions that drive business growth and enhance user experience.",

    // Work Experience (Engineering)
    experiences: [
      {
        jobTitle: "Senior Software Engineer",
        company: "TechCorp Inc.",
        experienceLocation: "San Francisco, CA",
        startDate: "Jan 2021",
        endDate: "Present",
        responsibilities: [
          "Led development of microservices architecture serving 5M+ users",
          "Mentored team of 5 junior developers and conducted code reviews",
          "Improved application performance by 40% through optimization",
          "Designed and implemented CI/CD pipelines reducing deployment time by 60%"
        ]
      }
    ],

    // Education
    education: [
      {
        degree: "Bachelor of Science in Computer Science",
        institution: "University of California, Berkeley",
        educationLocation: "Berkeley, CA",
        graduationDate: "May 2017",
        gpa: "3.8/4.0"
      },
      {
        degree: "Associate Degree in Software Development",
        institution: "Austin Community College",
        educationLocation: "Austin, TX",
        graduationDate: "May 2015",
        gpa: "3.9/4.0"
      }
    ],
    
    // Projects
    projects: [
      {
        projectName: "E-Commerce Platform",
        projectDescription: "Built a full-stack e-commerce platform with product catalog, shopping cart, payment integration, and admin dashboard. Handles 10K+ daily transactions.",
        projectTechnologies: "React, Node.js, MongoDB, Stripe API, AWS",
        projectDate: "2023",
        projectLink: "https://github.com/alexjohnson/ecommerce-platform"
      },
      {
        projectName: "Real-Time Chat Application",
        projectDescription: "Developed a scalable real-time messaging application with WebSocket support, user authentication, and message encryption.",
        projectTechnologies: "React, Socket.io, Express, PostgreSQL, Redis",
        projectDate: "2022",
        projectLink: "https://github.com/alexjohnson/chat-app"
      }
    ],
    
    // Certifications
    certifications: [
      {
        certificationName: "AWS Certified Solutions Architect - Professional",
        certificationIssuer: "Amazon Web Services",
        certificationDate: "2023"
      },
      {
        certificationName: "Google Cloud Professional Cloud Architect",
        certificationIssuer: "Google Cloud",
        certificationDate: "2022"
      }
    ],
    
    // Skills
    technicalSkills: [
      "JavaScript",
      "TypeScript",
      "React",
      "Node.js",
      "Python",
      "Java",
      "GraphQL",
      "REST APIs",
      "MongoDB",
      "PostgreSQL",
      "CI/CD",
      "Git"
    ],
    
    softSkills: [
      "Leadership",
      "Team Collaboration",
      "Problem Solving",
      "Communication",
      "Agile/Scrum",
      "Mentoring",
      "Project Management",
      "Critical Thinking"
    ],
    
    languages: [
      "English (Native)",
      "Spanish (Fluent)",
      "French (Conversational)"
    ],
    
    tools: [
      "VS Code",
      "Git",
      "Jira",
      "Figma",
      "Postman",
      "Jenkins",
      "GitHub Actions",
      "Terraform"
    ]
  };
};

// Get a minimal version for quick previews
export const getMinimalSampleData = () => {
  return {
    fullName: "John Doe",
    title: "Senior Software Engineer",
    email: "john.doe@email.com",
    phone: "+1 (555) 123-4567",
    location: "San Francisco, CA",
    summary: "Results-driven Software Engineer with 8+ years of experience building scalable applications.",
    
    experiences: [
      {
        jobTitle: "Senior Software Engineer",
        company: "TechCorp Inc.",
        startDate: "Jan 2021",
        endDate: "Present",
        responsibilities: [
          "Led development of microservices architecture",
          "Mentored team of 5 developers"
        ]
      }
    ],
    
    education: [
      {
        degree: "B.S. Computer Science",
        institution: "UC Berkeley",
        graduationDate: "May 2017"
      }
    ],
    
    technicalSkills: ["JavaScript", "React", "Node.js", "AWS", "Docker"],
    softSkills: ["Leadership", "Communication", "Problem Solving"]
  };
};